import { Link } from "react-router-dom";
import { SOCIALS, JOTFORM_URL } from "../lib/api";
import { InstagramIcon, TikTokIcon, FacebookIcon } from "./Icons";

export const Footer = () => (
  <footer className="foot" data-testid="site-footer">
    <div className="wrap">
      <div className="foot-grid">
        <div className="foot-lockup">
          <img src="/brand/lockup-t.png" alt="Dialed In — golf wellbeing brand" />
          <div className="foot-tag">Products for the person<br />carrying the bag.</div>
          <div className="foot-social" data-testid="footer-socials">
            <a href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="social-instagram"><InstagramIcon /></a>
            <a href={SOCIALS.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok" data-testid="social-tiktok"><TikTokIcon /></a>
            <a href={SOCIALS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Dialed In Community" data-testid="social-facebook"><FacebookIcon /></a>
          </div>
        </div>
        <div>
          <div className="foot-h">Explore</div>
          <div className="foot-links">
            <Link to="/research">Research</Link>
            <Link to="/prepare">Prepare</Link>
            <Link to="/our-story">Our Story</Link>
            <Link to="/the-science">The Science &middot; Weekly</Link>
            <Link to="/quiz">The Golfer Profile</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
        <div>
          <div className="foot-h">Take part</div>
          <div className="foot-links">
            <Link to="/#join">Join Dialed In</Link>
            <Link to="/prepare#waitlist">Prepare Waitlist</Link>
            <a href={JOTFORM_URL} target="_blank" rel="noopener noreferrer">Share Your Golf Experience</a>
            <a href={SOCIALS.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-community-link">Dialed In Community</a>
          </div>
          <div className="foot-h" style={{ marginTop: 34 }}>Legal</div>
          <div className="foot-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms &amp; Conditions</Link>
            <Link to="/cookies">Cookie Policy</Link>
          </div>
        </div>
      </div>
      <div className="foot-base">
        <span>&copy; {new Date().getFullYear()} Dialed In &middot; getdialedin.golf</span>
        <span>Golf gives people something worth protecting.</span>
      </div>
    </div>
  </footer>
);
